import type { JSX } from "react";

import { componentManager, rwc } from "@frontend/bridge/ComponentManager";

import { Background } from "./Background";
import {
  type BackgroundDataProps,
  backgroundDataSchema,
} from "./Background.schema";
import { BACKGROUND_TAG_NAME } from "./constants";

declare module "@frontend/bridge/types" {
  interface ComponentRegistryMap {
    [BACKGROUND_TAG_NAME]: { props: BackgroundDataProps; handle: undefined };
  }
}

declare global {
  interface HTMLElementTagNameMap {
    "rwc-background": HTMLElement;
  }
}

function RWCBackground(props: BackgroundDataProps): JSX.Element {
  return <Background {...props} />;
}

componentManager.register(
  rwc(BACKGROUND_TAG_NAME, {
    component: RWCBackground,
    dataSchema: backgroundDataSchema,
  }),
);
